/* eslint-disable no-return-assign */
/**
 * Drop elements from array while predicate is true
 * @param  {array}    source    array to take while from
 * @param  {function} predicate function which returns either true or false
 * @return {array}              array which has been taken from the source
 */
export default function dropWhile(source, predicate) {
  let stopIndex = source.length;
  source.some((n, idx) => (
    predicate(n, idx) ? false : ((stopIndex = idx), true) // fun trick with comma operator (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comma_Operator)
  ));

  return source.slice(stopIndex);
}



// WEBPACK FOOTER //
// ./app/utils/array/dropWhile.js